<template>
  <div class="clerk-list">
    <div class="relative">
      <div class="input-wrapper hd">
        <div class="input-box">
          <span class="name">商家名称：</span>
          <div class="input">
            <el-select
              v-model="form.merchantName"
              placeholder="请选择"
              clearable
            >
              <el-option
                :value="item.label"
                :label="item.label"
                v-for="item in filterDownData('merchantList')"
                :key="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="input-box">
          <span class="name">店员名称：</span>
          <div class="input">
            <el-input v-model="form.clerkName" placeholder="请输入" clearable />
          </div>
        </div>
        <div class="input-box">
          <span class="name">店员手机号码：</span>
          <div class="input">
            <el-input v-model="form.phone" placeholder="请输入" clearable />
          </div>
        </div>
        <el-button
          size="60"
          round
          class="iconfont icon-sousuo"
          @click="searchData"
        />
      </div>
      <transition-group class="list" tag="ul" name="flip-list" v-min-height>
        <li class="item" v-for="(item, index) in tableData" :key="item.id">
          <div class="box">
            <div class="header">
              <el-image :src="item.imgUrl" class="avatar">
                <div slot="error" class="image-slot">
                  <i class="iconfont icon-tupian"></i>
                </div>
              </el-image>
              <div class="info">
                <p class="name ellipses">
                  {{ item.salesName }}
                </p>
                <p class="identify">
                  {{ item.salesPosition }}
                </p>
              </div>
            </div>
            <div class="details">
              <p class="intro">本月销售额</p>
              <p class="sales-money">
                {{ item.currentMonthSales | formatMoney }}
              </p>
              <div class="sales-info">
                <p class="month">
                  近三月：<span class="money">{{
                    item.threeMonthSales | formatMoney
                  }}</span>
                </p>
                <p class="month">
                  近六月：<span class="money">{{
                    item.sixMonthSales | formatMoney
                  }}</span>
                </p>
                <p class="month">
                  近一年：<span class="money">{{
                    item.twelveMonthSales | formatMoney
                  }}</span>
                </p>
              </div>
            </div>
            <div class="operator">
              <el-button
                size="36"
                round
                v-permission:del="$route.meta.permission"
                class="iconfont icon-shanchu"
                @click="deleteItem(item.id, index)"
              />
              <el-button
                size="36"
                round
                v-permission:editor="$route.meta.permission"
                class="iconfont icon-bianji"
                @click="editor(item, index)"
              />
              <el-button
                size="36"
                round
                v-permission:details="$route.meta.permission"
                class="iconfont icon-chakanxiangqing"
                @click="jumpRoute(item)"
              />
            </div>
          </div>
        </li>
      </transition-group>
      <Pagination
        v-if="pagination.recordTotal > 1"
        :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal"
        :totalRecord="pagination.recordTotal"
        @handleNextPage="nextPage"
        @handlePrevPage="prevPage"
        @handleJumpPage="jumpPage"
        @handleChangePageSize="changePageSize"
      />
      <el-button
        size="220"
        round
        class="iconfont icon-xinzeng"
        @click="editor"
        v-permission:add="$route.meta.permission"
      >
        新增顾问
      </el-button>
      <div class="mask foot-fixed" v-if="dialogFormVisible">
        <el-dialog
          :visible.sync="dialogFormVisible"
          :modal-append-to-body="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="true"
          custom-class="dialog"
          :modal="false"
          width="50%"
          :center="true"
        >
          <el-Scrollbar :native="false">
            <el-upload
              class="uploader"
              action="/"
              ref="upload"
              accept=".jpg,.jpeg,.png"
              :auto-upload="false"
              :show-file-list="false"
              :file-list="dialogForm.fileList"
              :before-upload="_beforeLimitUpload"
              :http-request="
                _appendFormDataInfo.bind(null, dialogForm.fileList)
              "
              :on-change="
                handleAddItemData.bind(
                  null,
                  'dialogForm.fileList',
                  handleChange
                )
              "
            >
              <img
                v-if="dialogForm.imgUrl"
                :src="dialogForm.imgUrl"
                class="preview-img"
              />
              <img
                class="default-img"
                v-if="!dialogForm.imgUrl"
                src="../../../assets/img/avatar-default.png"
              />
            </el-upload>
            <p class="intro">上传头像</p>
            <el-form :model="dialogForm" label-width="auto">
              <el-form-item
                label="所属商家："
                class="center"
                v-if="$store.state.entryType !== 'seller'"
              >
                <div class="input-box">
                  <div class="input">
                    <el-select
                      v-model="dialogForm.merchantId"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                        v-for="item in filterDownData('merchantList')"
                      />
                    </el-select>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="姓名：" class="center">
                <div class="input-box">
                  <div class="input">
                    <el-input
                      v-model="dialogForm.salesName"
                      placeholder="请输入"
                      clearable
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="性别：" class="center">
                <div class="input-box">
                  <div class="input">
                    <el-select
                      placeholder="请选择"
                      clearable
                      v-model="dialogForm.sex"
                    >
                      <el-option
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                        v-for="item in filterDownData('genderList')"
                      />
                    </el-select>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="手机号码：" class="center">
                <div class="input-box">
                  <div class="input">
                    <el-input
                      v-model="dialogForm.phone"
                      placeholder="请输入"
                      clearable
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="职位：" class="center">
                <div class="input-box">
                  <div class="input">
                    <el-input
                      v-model="dialogForm.salesPosition"
                      placeholder="请输入"
                      clearable
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="是否销售业绩提成：" class="center">
                <div class="input-box">
                  <div class="input">
                    <input
                      class="mui-switch mui-switch-animbg"
                      v-model="dialogForm.isCommission"
                      type="checkbox"
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                v-if="dialogForm.isCommission"
                label="提成比例："
                style="margin-bottom: 3.3rem"
                class="center"
              >
                <div class="input-box" style="margin-bottom: 1rem">
                  <div class="input">
                    <el-input
                      v-model="dialogForm.crossRatio"
                      type="number"
                      placeholder="请输入"
                      clearable
                    />
                  </div>
                  %（跨境）
                </div>
                <div class="input-box">
                  <div class="input">
                    <el-input
                      type="number"
                      v-model="dialogForm.dutyRatio"
                      placeholder="请输入"
                      clearable
                    />
                  </div>
                  %（完税）
                </div>
              </el-form-item>
              <el-form-item
                label="个人月度销售金额："
                :class="index !== 0 && 'none'"
                v-for="(item, index) in dialogForm.personalRules"
                :key="index"
              >
                <div class="input-box">
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      v-model="item.startAmount"
                      type="number"
                      clearable
                    />
                  </div>
                  至
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      v-model="item.endAmount"
                      type="number"
                      clearable
                    />
                  </div>
                  <span class="name" style="margin-left:2.8rem ">返佣金：</span>
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      type="number"
                      v-model="item.commissionRatio"
                      clearable
                    />
                  </div>
                  %
                  <el-button
                    style="margin-left: 1rem"
                    v-if="index === 0"
                    class="sub-color iconfont icon-tianjia"
                    round
                    size="36"
                    @click="addLine('personalRules')"
                  />
                  <el-button
                    style="margin-left: 1rem"
                    v-if="index !== 0"
                    class="del-color iconfont icon-shanchu"
                    round
                    @click="delLine('personalRules', index)"
                    size="36"
                  />
                </div>
              </el-form-item>
              <el-form-item
                label="团队月度销售金额："
                :class="index !== 0 && 'none'"
                v-for="(item, index) in dialogForm.teamRules"
                :key="-index - 1"
              >
                <div class="input-box">
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      type="number"
                      v-model="item.startAmount"
                      clearable
                    />
                  </div>
                  至
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      type="number"
                      v-model="item.endAmount"
                      clearable
                    />
                  </div>
                  <span class="name" style="margin-left:2.8rem ">返佣金：</span>
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      type="number"
                      v-model="item.commissionRatio"
                      clearable
                    />
                  </div>
                  %
                  <el-button
                    style="margin-left: 1rem"
                    v-if="index === 0"
                    class="sub-color iconfont icon-tianjia"
                    round
                    size="36"
                    @click="addLine('teamRules')"
                  />
                  <el-button
                    style="margin-left: 1rem"
                    v-if="index !== 0"
                    class="del-color iconfont icon-shanchu"
                    round
                    @click="delLine('teamRules', index)"
                    size="36"
                  />
                </div>
              </el-form-item>
            </el-form>
          </el-Scrollbar>
          <div slot="footer" class="dialog-footer">
            <el-button size="98" @click="dialogFormVisible = false">
              取 消
            </el-button>
            <el-button class="sub-color" size="98" @click="saveInfo">
              确 定
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from 'mixins/pagination/'
import filterDownData from 'mixins/filterDownData'
import uploadImg from 'mixins/uploadImg/'
import { createNamespacedHelpers } from 'vuex'

const { mapMutations } = createNamespacedHelpers('clerkInfo')

export default {
  name: 'clerkList',
  mixins: [pagination, filterDownData, uploadImg],
  data() {
    this.keyMap = {
      salesman_list: {
        name: 'tableData',
        sales_id: 'id',
        sales_name: 'salesName',
        sales_position: 'salesPosition',
        cross_proportion: 'crossRatio',
        duty_proportion: 'dutyRatio',
        image_url: 'imgUrl',
        current_month: 'currentMonthSales',
        three_month: 'threeMonthSales',
        six_month: 'sixMonthSales',
        twelve_month: 'twelveMonthSales',
        merchant_id: 'merchantId',
        merchant_name: 'merchantName',
        mob_phone: 'phone',
        personal_sales_rules: 'personalRules',
        team_sales_rules: 'teamRules',
        sales_end_amount: 'endAmount',
        sales_start_amount: 'startAmount',
        commission_rate: 'commissionRatio',
        is_royalty: 'isCommission',
        royalty_type: 'royaltyType',
        sales_sex: 'sex',
        rule_id: 'ruleId'
      }
    }
    this.type = 'pagination'
    return {
      tableData: [],
      pagination: {},
      form: {},
      dialogForm: {
        imgUrl: '',
        isCommission: 1,
        fileList: [],
        teamRules: [
          {
            royaltyType: '2',
            startAmount: '',
            endAmount: '',
            commissionRatio: ''
          }
        ],
        personalRules: [
          {
            royaltyType: '1',
            startAmount: '',
            endAmount: '',
            commissionRatio: ''
          }
        ]
      },
      dialogFormVisible: false
    }
  },
  created() {
    this._getClerkList({
      curpage: 1
    })
  },
  methods: {
    ...mapMutations({
      saveClerkInfo: 'CHANGE_CLERKINFO'
    }),
    /**
     * 获取列表
     * @param params
     * @private
     */
    _getClerkList(params) {
      this.api.clerkList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 翻页
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      this._getClerkList({
        curpage: newValue,
        pageSize: size
      })
    },
    /**
     * 搜索
     */
    searchData() {
      const { clerkName, merchantName, phone } = this.form
      const data = {
        sales_name: clerkName,
        mob_phone: phone,
        merchant_id: merchantName
      }
      this._getClerkList(data)
    },
    /**
     * 删除销售人员
     * @param id
     * @param index
     */
    deleteItem(id, index) {
      this.$confirm('删除该店员?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '删除',
        showClose: false,
        cancelButtonClass: 'el-button--98',
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.api
            .delClerk({
              sales_id: id
            })
            .then(() => {
              this.$notify({
                type: 'success',
                message: '删除成功~！🙂'
              })
              this._getClerkList({
                curpage: this.pagination.currentPage || 1
              })
            })
        })
        .catch(() => {})
    },
    /**
     * 编辑(新增)员工
     * @param item
     */
    editor(item) {
      if (item.id) {
        this.dialogForm = item
      } else {
        this.dialogForm = {
          imgUrl: '',
          isCommission: 1,
          fileList: [],
          teamRules: [
            {
              royaltyType: '2',
              startAmount: '',
              endAmount: '',
              commissionRatio: ''
            }
          ],
          personalRules: [
            {
              royaltyType: '1',
              startAmount: '',
              endAmount: '',
              commissionRatio: ''
            }
          ]
        }
      }
      this.dialogFormVisible = !this.dialogFormVisible
    },
    /**
     * 跳转详情
     * @param item
     */
    jumpRoute(item) {
      this.saveClerkInfo(item) // 储存到store
      this.$router.push({
        name: 'clerkDetails',
        query: {
          id: item.id,
          title: '店员信息'
        }
      })
    },
    /**
     * 添加行
     * @param prop
     */
    addLine(prop) {
      const type = prop === 'teamRules' ? '2' : '1'
      const line = {
        startAmount: '',
        endAmount: '',
        commissionRatio: '',
        royaltyType: type
      }
      this.dialogForm[prop].push(line)
    },
    /**
     * 删除行
     * @param prop
     * @param index
     */
    delLine(prop, index) {
      const row = this.dialogForm
      const id = row.id
      const ruleId = row[prop][index].ruleId
      if (id) {
        this.api
          .delClerkSalesRule({
            sales_id: id,
            rule_id: ruleId
          })
          .then(() => {
            this.$notify({
              type: 'success',
              message: '删除成功~！😁'
            })
          })
      }
      row[prop].splice(index, 1)
    },
    /**
     * 文件上传改变
     * @param file
     */
    handleChange(file) {
      this.dialogForm.imgUrl = URL.createObjectURL(file.raw)
      this.dialogForm.fileList = this.dialogForm.fileList.slice(-1)
    },
    /**
     * 新增店员信息
     */
    saveInfo() {
      const newMap = this.utils._reverseObj(this.keyMap)
      const data = {
        tableData: this.utils._cloneDeep(this.dialogForm)
      }
      data.tableData.isCommission = data.tableData.isCommission ? 1 : 0
      this.utils._modifyObjKey(data, newMap)
      this._handleUpload('upload')
      this.formData.append('data', JSON.stringify(data.salesman_list))
      if (this.isUpload) {
        this.api.editorClerkFormData(this.formData).then(() => {
          this.$notify({
            type: 'success',
            message: '保存成功~！😁'
          })
          this.dialogFormVisible = false
          this._getClerkList({
            curpage: this.pagination.currentPage || 1
          })
        })
      }
    }
  }
}
</script>
<style lang="scss">
.clerk-list {
  .list {
    margin-right: -1.3rem;
    padding-bottom: 4.1rem;
    @extend .clearfix;
  }

  .item {
    width: calc(20% - 1.3rem);
    float: left;
    height: 29.4rem;
    margin: 0 1.3rem 1.3rem 0;
    @include bg-color__fff();
    @include maxScreenWidth(1800) {
      width: calc(25% - 1.3rem);
    }
    @include maxScreenWidth(1440) {
      width: calc(33.33% - 1.3rem);
    }
  }

  .box {
    width: 100%;
    height: 100%;
    padding: 1.8rem;
  }

  .header {
    padding-bottom: 2rem;
    border-bottom: 1px dashed #d8d8d8;

    .info {
      display: inline-block;
      vertical-align: middle;
    }

    .avatar {
      width: 5.8rem;
      height: 5.8rem;
      display: inline-block;
      border-radius: 50%;
      background-color: #f7f7f7;
      margin-right: 2.2rem;
      vertical-align: middle;
    }

    .name {
      font-size: 1.3rem;
      font-weight: bold;
    }

    .identify {
      font-size: 0.9rem;
    }

    .percent {
      width: 3.8rem;
      height: 1.5rem;
      background-color: colors('bg-main');
      border-radius: 1rem;
      color: #fff;
      text-align: center;
      line-height: 1.5rem;
      margin-top: 0.2rem;
    }
  }

  .details {
    .intro {
      margin-top: 1.8rem;
      text-align: center;
      margin-bottom: 0.3rem;
    }

    .sales-money {
      width: 7.9rem;
      height: 2.5rem;
      margin: 0 auto;
      border-radius: 1.4rem;
      border: solid 0.1rem #000;
      text-align: center;
      line-height: 2.5rem;
      font-size: 1rem;
    }

    .sales-info {
      margin: 2.6rem 0 1.9rem 0;
    }

    .month {
      position: relative;
      margin-bottom: 0.6rem;
      font-size: 0.9rem;
      padding-left: 1rem;
      @include dots(#ff3649, -1rem, 0.4rem);

      &:nth-child(2) {
        &:before {
          background-color: colors('d5');
        }
      }

      &:nth-child(3) {
        &:before {
          background-color: colors('37');
        }
      }
    }
  }

  .icon-bianji {
    background-color: colors('d5');
  }

  .icon-chakanxiangqing {
    background-color: colors('bg-sub');
  }

  .el-button--220 {
    bottom: 0;
  }

  .mask {
    .el-dialog__body {
      padding: 25px 50px 30px;
    }

    .uploader {
      width: 5.8rem;
      height: 5.8rem;
      margin: 0 auto;
      border-radius: 50%;
      background-color: #f7f7f7;

      .el-upload {
        display: block;
        height: 100%;
      }
    }

    .intro {
      text-align: center;
      padding: 0.6rem 0 2.8rem 0;
    }

    .none {
      .el-form-item__label {
        opacity: 0;
      }
    }

    .center {
      &.el-form-item {
        display: flex;
        justify-content: center;
      }

      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }

  .pagination {
    bottom: 1rem;
    margin-left: 2rem;
  }

  .el-dialog {
    overflow: hidden;
    height: 40rem;
    @include maxScreenWidth(1366) {
      height: 30rem;
    }
    .el-form {
      padding-bottom: 4rem;
    }
  }
}
</style>
